import { PluginKey } from 'prosemirror-state'

export const NodeHandlesPluginKey = new PluginKey('nodeHandles')

export type HandleState = { pos: number; type: HandleType }

export type NodeHandlesPluginState = {
  hoveredNode: HandleState | null
  timestamp: number
  previousHandles: { pos: number; key: string; type: HandleType }[]
}

export const enum HandleType {
  DRAG_HANDLE,
  DRAG_SOURCE_HANDLE,
  INSERT_HANDLE,
}
